// Reference: https://docs.oasis-open.org/odata/odata/v4.0/errata03/os/complete/part2-url-conventions/odata-v4.0-errata03-os-part2-url-conventions-complete.html

const buildODataFilter = (filter, customFilter = {}, isRoot = true) => {
  if (!filter) {
    return null
  }

  if (filter.includes('or')) {
    let filterExpressions = filter
      .filter(x => x !== 'or')
      .map(x => buildODataFilter(x, customFilter, false))
    const joined = filterExpressions.join(' or ')
    return isRoot ? joined : `(${joined})`
  } else if (filter.includes('and')) {
    let filterExpressions = filter
      .filter(x => x !== 'and')
      .map(x => buildODataFilter(x, customFilter, false))
    const joined = filterExpressions.join(' and ')
    return isRoot ? joined : `(${joined})`
  } else {
    return buildODataFilterExpression(filter, customFilter)
  }
}

const buildODataSorting = sorting => {
  return sorting
    ? sorting.map(s => `${s.selector} ${s.desc ? 'desc' : 'asc'}`).join(',')
    : null
}

const buildODataFilterExpression = (filterExpression, customFilter = {}) => {
  const field = filterExpression[0]
  const operator = filterExpression[1]
  let value = filterExpression[2]

  if (customFilter[field]) {
    return customFilter[field](field, operator, value)
  }

  value = parseValue(value)

  if (
    operator === 'contains' ||
    operator === 'startswith' ||
    operator === 'endswith'
  ) {
    return `${operator}(${field}, ${value})`
  }
  if (operator === 'notcontains') {
    return `contains(${field}, ${value}) eq false`
  }
  if (operator === '=') {
    return `${field} eq ${value}`
  }
  if (operator === '<>') {
    return `${field} ne ${value}`
  }
  if (operator === '>') {
    return `${field} gt ${value}`
  }
  if (operator === '>=') {
    return `${field} ge ${value}`
  }
  if (operator === '<') {
    return `${field} lt ${value}`
  }
  if (operator === '<=') {
    return `${field} le ${value}`
  }

  return null
}

const parseValue = rawValue => {
  const type = typeof rawValue

  if (type === 'string') {
    if (isISODateString(rawValue)) {
      return new Date(rawValue).toISOString()
    }
    rawValue = `'${rawValue}'`
  }
  return rawValue
}

const isISODateString = str => {
  const isoRegex =
    /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(?:\.\d+)?(?:Z|[+-]\d{2}:\d{2})?$/
  return isoRegex.test(str)
}

export { buildODataFilter, buildODataSorting }
